module.exports = __webpack_public_path__ + "static/media/heart-of-swirls-in-floral-ornamental-design-svgrepo-com.49d4cda3.svg";